// extracted by mini-css-extract-plugin
module.exports = {"list":"navbar_list__2h5Aa","container":"navbar_container__1DjA0"};